import { render, staticRenderFns } from "./album-list.vue?vue&type=template&id=0a3bc484&scoped=true&"
import script from "./album-list.vue?vue&type=script&lang=js&"
export * from "./album-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3bc484",
  null
  
)

export default component.exports